import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getUserdata } from "../Redux/Action";
import { FiCheckCircle, FiXCircle, FiAlertCircle, FiClock } from "react-icons/fi";
import "../App.css";

export const StripePaymentResult = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [countdown, setCountdown] = useState(5); // 5 seconds countdown
  const [progressValue, setProgressValue] = useState(100); // Progress bar value

  useEffect(() => {
    // Parse query parameters only once
    const queryParams = new URLSearchParams(window.location.search);
    const sessionId = queryParams.get("session_id");
    const result = queryParams.get("result");
    
    let status = "Unknown";
    let StatusIcon = FiAlertCircle;
    let statusColor = "#718096"; // gray.500
    
    if (result === "success") {
      status = "Success";
      StatusIcon = FiCheckCircle;
      statusColor = "#48BB78"; // green.500
    } else if (result === "failed" || result === "cancel" || result === "cancelled") {
      status = "Cancelled";
      StatusIcon = FiXCircle;
      statusColor = "#ED8936"; // orange.500
    }

    setData([
      {
        label: "Status",
        value: (
          <div className="badge" style={{ backgroundColor: statusColor }}>
            <div className="status-content">
              <StatusIcon className="status-icon" />
              <span>{status}</span>
            </div>
          </div>
        ),
      },
      {
        label: "Session ID",
        value: sessionId ? (
          <div className="session-id-container">
            {sessionId}
          </div>
        ) : "N/A",
      },
    ]);

    // If payment was successful, set a flag in localStorage to trigger refresh
    if (result === "success") {
      dispatch(getUserdata());
      localStorage.setItem('stripePaymentSuccess', 'true');
    }

    // Countdown timer
    const countdownInterval = setInterval(() => {
      setCountdown(prev => {
        // Update progress bar
        setProgressValue(prev => prev - 20);
        
        if (prev <= 1) {
          clearInterval(countdownInterval);
          window.close();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    // Auto-close the window after 5 seconds
    const timer = setTimeout(() => {
      window.close();
    }, 5000);

    return () => {
      clearTimeout(timer);
      clearInterval(countdownInterval);
      // Clean up the flag when component unmounts
      if (localStorage.getItem('stripePaymentSuccess') === 'true') {
        localStorage.removeItem('stripePaymentSuccess');
      }
    };
  }, []);

  return (
    <div className="payment-result-container">
      <div className="payment-result-card">
        {/* Warning text at the top */}
        <div className="warning-text">
          Do not close or refresh the window
        </div>
        
        <div className="icon-container">
          <div className="icon-circle">
            <FiClock className="clock-icon" />
          </div>
        </div>
        
        <h2 className="heading">Payment Processing</h2>
        
        <p className="subtitle">
          Your Stripe payment is being processed
        </p>
        
        <div className="progress-container">
          <div 
            className="progress-bar" 
            style={{ width: `${progressValue}%` }}
          ></div>
        </div>
        
        <div className="data-list">
          {data.map((item) => (
            <div key={item.label} className="data-item">
              <span className="data-label">{item.label}</span>
              <div className="data-value">{item.value}</div>
            </div>
          ))}
          <div className="data-item">
            <span className="data-label">Auto-Closing</span>
            <div className="data-value">
              <span className="countdown-text">
                This page will close in <strong>{countdown}</strong> seconds...
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};